module.exports = __webpack_public_path__ + "static/apple-touch-icon-114x114-1b91c618ec25f8270b06874d39215fbe.png";